/**
 * Theme configuration for styled-components (React Web)
 * Contains color palette, typography, spacing, and other design tokens
 */
export const theme = {
  colors: {
    primary: '#F6B400',
    primaryLight: '#FFD166',
    primaryDark: '#D18A00',
    secondary: '#8B5A2B',
    secondaryLight: '#A0713A',
    success: '#10B981',
    successLight: '#34D399',
    danger: '#EF4444',
    dangerLight: '#F87171',
    warning: '#F59E0B',
    warningLight: '#FBBF24',
    info: '#2563EB',
    infoLight: '#60A5FA',
    light: '#FFFDF5',
    lightHover: '#FFF7E8',
    dark: '#2B1A0F',
    darkHover: '#3D2414',
    white: '#FFFFFF',
    black: '#1F1108',
    background: '#FFF9EE',
    backgroundSecondary: '#FFFDF5',
    text: '#2B1A0F',
    textSecondary: '#6B4A2B',
    textTertiary: '#A0713A',
    border: '#F0E2C6',
    borderLight: '#F8EFD8',
    shadow: 'rgba(44, 24, 8, 0.12)',
    shadowHover: 'rgba(44, 24, 8, 0.18)',
    honey: '#F6B400',
    honeycomb: '#FFD166',
    amber: '#D18A00',
    beeYellow: '#FDB813',
    hiveWood: '#8B5A2B',
    darkWood: '#6B3E0B',
  },
  typography: {
    fontFamily: {
      primary:
        "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif",
      mono: "'Fira Code', 'Courier New', monospace",
    },
    fontSize: {
      xs: '13px',
      small: '15px',
      medium: '18px',
      large: '22px',
      xlarge: '28px',
      xxlarge: '36px',
      xxxlarge: '48px',
    },
    fontWeight: {
      normal: '400',
      medium: '500',
      semibold: '600',
      bold: '700',
    },
    lineHeight: {
      tight: '1.25',
      normal: '1.5',
      relaxed: '1.75',
    },
  },
  spacing: {
    xs: '8px',
    sm: '14px',
    md: '22px',
    lg: '36px',
    xl: '48px',
    xxl: '64px',
    xxxl: '88px',
  },
  borderRadius: {
    small: '6px',
    medium: '8px',
    large: '12px',
    xlarge: '16px',
    xxlarge: '24px',
    full: '9999px',
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  },
  transitions: {
    fast: '0.15s ease-in-out',
    normal: '0.2s ease-in-out',
    slow: '0.3s ease-in-out',
  },
}
